import types from './types'
import { currentNotifications } from '../../api'
import _cloneDeep from 'lodash.clonedeep'

const setNotifications = (data) => ({ type: types.update, data })

const getNotifications = () => (dispatch) => {
  currentNotifications.getNotifications()
    .then(({ data, status }) => {
      if (status === 200) dispatch(setNotifications(data.results))
    })
}

const updateNotifications = (data) => async (dispatch, getState) => {
  let status = 'PENDING'

  const { currentNotifications: currentNotificationsData } = getState()
  const prevCurrentNotificationsData = _cloneDeep(currentNotificationsData)
  dispatch(setNotifications(data))

  if (data.channels?.some(channel => !channel.key || !channel.hub || !channel.sound )) return status

  try {
    await currentNotifications.updateNotifications(data)
    status = 'OK'
  } catch (error) {
    dispatch(setNotifications(prevCurrentNotificationsData))
    status = 'ERROR'
  }

  return status
}

export {
  setNotifications,
  getNotifications,
  updateNotifications
}
